/* eslint-disable no-unused-vars */
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'

export const parseLinks = text => {
  if (!text) return ''

  const urlRegex = /(https?:\/\/[^\s]+)/g

  return text.replace(
    urlRegex,
    url =>
      `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
  )
}

const Wrapper = styled.div`
  text-align: center;

  @media (min-width: 480px) {
    padding: 20px;
  }
`

const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`

const Message = styled.p`
  font-size: 14px;
  color: #555;
  line-height: 1.5;
`

const TextWrapper = styled.div`
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  color: #333;

  a {
    color: #0070f3;
    text-decoration: underline;
    word-break: break-all;
  }
`

export default function AnnouncementText({ data }) {
  const html = parseLinks(data.text_content)
  return <TextWrapper dangerouslySetInnerHTML={{ __html: html }} />
}
